module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.top > 0) ? _c('span', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.backTop.apply(null, arguments)
      }
    }
  }, [_c('v-btn', {
    staticClass: "mt-5 blue",
    attrs: {
      "icon": "",
      "fab": "",
      "id": "scroll",
      "medium": "",
      "floating": ""
    }
  }, [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("keyboard_arrow_up")])], 1), _vm._v(" "), _vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03a7168d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/sections/BackTop.vue
// module id = 431
// module chunks = 0